import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  width: 1000px;
  margin: 0 auto;

  .mantine-Carousel-controls {
    button {
      background-color: #11998e;
      color: #000;
      zoom: 1.5;
    }
  }
`;
